import PropTypes from 'prop-types';
import React from 'react';
import Box from '../box/box.jsx';
import classNames from 'classnames';
import styles from './connection-modal.css';

const DeviceSelectStep = props => (
    <Box className={styles.body}>
        <Box className={styles.activityArea}>
            <div className={styles.deviceSelectionArea}>
                <h2 className={styles.deviceSelectionTitle}>
                    Bağlanmak istediğiniz cihaz türünü seçin
                </h2>
                <div className={styles.deviceTypeList}>
                    <div 
                        className={styles.deviceTypeItem}
                        onClick={() => props.onSelectDevice('bluetooth')}
                    >
                        <div className={styles.deviceTypeItemInner}>
                            <div className={styles.deviceTypeIcon}>
                                <div style={{
                                    width: '48px',
                                    height: '48px',
                                    backgroundColor: '#4D97FF',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'white',
                                    fontSize: '24px'
                                }}>
                                    📶
                                </div>
                            </div>
                            <div className={styles.deviceTypeName}>
                                Bluetooth
                            </div>
                            <div className={styles.deviceTypeDescription}>
                                LEGO, Micro:bit ve diğer Bluetooth cihazlar
                            </div>
                        </div>
                    </div>
                    <div 
                        className={styles.deviceTypeItem}
                        onClick={() => props.onSelectDevice('serial')}
                    >
                        <div className={styles.deviceTypeItemInner}>
                            <div className={styles.deviceTypeIcon}>
                                <div style={{
                                    width: '48px',
                                    height: '48px',
                                    backgroundColor: '#FF6B35',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: 'white',
                                    fontSize: '24px'
                                }}>
                                    🔌
                                </div>
                            </div>
                            <div className={styles.deviceTypeName}>
                                Seri Port
                            </div>
                            <div className={styles.deviceTypeDescription}>
                                Arduino ve diğer USB cihazları
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Box>
        <Box className={styles.bottomArea}>
            <div className={classNames(styles.bottomAreaItem)}>
                <button
                    className={classNames(styles.connectionButton)}
                    onClick={props.onCancel}
                >
                    İptal
                </button>
            </div>
        </Box>
    </Box>
);

DeviceSelectStep.propTypes = {
    onCancel: PropTypes.func.isRequired,
    onSelectDevice: PropTypes.func.isRequired
};

export default DeviceSelectStep; 